import { createFileRoute, redirect } from "@tanstack/react-router"

/** `/ask?q=` — block 16's old Enter target, kept as a redirect into a new thread (block 17). */
export const Route = createFileRoute("/_authed/ask/")({
  validateSearch: (search: Record<string, unknown>): { q?: string } =>
    typeof search.q === "string" ? { q: search.q } : {},
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/ask/$threadId", params: { threadId: "new" }, search, replace: true })
  },
})
